import { app } from '../../../../bootstrap/core';
import { ticketNotesComponent } from './ticketNotes.component';

app.component('ticketNotes', ticketNotesComponent);
